<div class="self-signup-container">
  <div class="fixed-top-section">
    <img alt="Vendasta" src="../assets/images/vendasta-logo.png" width="160" height="24" />
  </div>

  <div class="self-signup-content">
    <app-sign-up-form #signUpForm [loginURL]="loginURL"></app-sign-up-form>
  </div>
</div>
